
import RouterDefault from './libs/router/main';
var Router = RouterDefault.default;
import Url from 'url';
import _ from 'lodash';

export default class AppRouter {
    locale = null;
    routes = {};
    router = null;
    useLocale = false;

    constructor(routes, locale = null, useLocale = false) {
        this.routes = routes;
        this.locale = locale;
        this.useLocale = useLocale;

        this.router = new Router();
        this.router.map(function(match) {
            let pattern;
            _.forEach(routes, function(route, name) {
                if (useLocale) {
                    pattern = '/:locale/' + _.trimStart(route.pattern, '/');
                } else {
                    pattern = route.pattern;
                }

                match(pattern).to(name);
            });
        });

        var routeHandlers = {};
        for (var name in routes) {
            var route = routes[name];
            if (route.hasOwnProperty('handler') && (typeof route.handler == 'function')) {
                routeHandlers[name] = {
                    model: route.handler,
                    serialize: function(obj) {
                        return obj;
                    }
                };
            } else {
                routeHandlers[name] = {
                    setup() {},
                    serialize: function(obj) {
                        return obj;
                    }
                };
            }
        }

        this.router.getHandler = function(name) {
            return routeHandlers[name];
        };
    }

    resolveCurrentURL() {
        var currentUrl = window.location.href;
        var url = Url.parse(currentUrl);

        this.router.handleURL(url.path);
    }

    generate(routeName, params = null) {
        if (this.useLocale && null !== this.locale) {
            return this.generateI18n(routeName, params);
        }

        if (null !== params) {
            return this.router.generate(routeName, params);
        }

        return this.router.generate(routeName);
    }

    generateI18n(routeName, params = null) {
        if (null !== params) {
            return this.router.generate(routeName, _.extend({}, params, {
                locale: this.locale
            }));
        }

        return this.router.generate(routeName, {
            locale: this.locale
        });
    }
}
